export default "__VITE_PUBLIC_ASSET__56f8e8a7__"